import { BusinessInsights } from "components/BooksHomePage/BusinessInsights/BusinessInsights";
import { BusinessOverview } from "components/BooksHomePage/BusinessOverview/BusinessOverview";
import { CashBalance } from "components/BooksHomePage/CashBalance/CashBalance";
import {
  HideBalancesAndAmounts,
  HideBalancesAndAmountsProvider,
} from "components/BooksHomePage/HideBalancesAndAmounts";
import { RecentFinancials } from "components/BooksHomePage/RecentFinancials/RecentFinancials";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { DashboardLayout } from "components/DashboardLayout";
import Loader from "components/DesignSystem/Loader/loader";
import { Header } from "components/DesignSystem/Header/Header";
import { PromotionalCarousel } from "components/home/TaxComponents/PromotionalCarousel";
import { HomeActionItems } from "components/HomeActionItems/HomeActionItems";
import { CATEGORISATION_TYPE } from "constants/booksHomePage";
import * as PRODUCT_ONBOARDING from "constants/productOnboardings";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { usePageTitle } from "hooks/usePageTitle";
import { useQuery } from "hooks/useQuery";
import authContext from "jwt_context&axios/authContext";
import { useContext, useRef } from "react";
import {
  useGetEntityBooksOnboardingStatusQuery,
  useGetOnboardingProductsQuery,
} from "store/apis/productOnboarding";
import { BooksOnboarding } from "./BooksOnboarding";
import { GetStartedCard } from "./GetStartedCard";

const BooksHomePage = () => {
  usePageTitle("Books Dashboard");
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();

  const {
    authtoken: { first_name },
  } = useContext(authContext);

  const {
    data: products,
    isLoading,
    isSuccess,
  } = useGetOnboardingProductsQuery(
    {
      groupId: groupId!,
    },
    { skip: !groupId }
  );

  const isBooksOnboardingComplete =
    !products?.length ||
    products.find((p) => p.name === PRODUCT_ONBOARDING.BOOKS)?.status ===
      "COMPLETED";

  const isCompleteRef = useRef(false);

  const { data: onboardingStatus, isLoading: isStatusLoading } =
    useGetEntityBooksOnboardingStatusQuery(
      { entityId: entityId! },
      {
        skip: !entityId || !isBooksOnboardingComplete,
        pollingInterval: isCompleteRef.current ? 0 : 30000,
      }
    );

  const isOnboardingStatusComplete =
    onboardingStatus?.loading_metrics_status === "COMPLETED" ||
    onboardingStatus?.transaction_pull_status === "NOT_STARTED";

  isCompleteRef.current = isOnboardingStatusComplete;

  if (isLoading || !isSuccess) {
    return <Loader />;
  }

  // if (isBooksOnboardingComplete && isStatusLoading) {
  //   return <Loader />;
  // }

  // if (isBooksOnboardingComplete && !isOnboardingStatusComplete) {
  //   return (
  //     <DashboardContainer className="t-items-center">
  //       <DashboardContainer.Content className="t-w-3/5">
  //         <DashboardLayout
  //           header={<Header v2 title="Welcome to Inkle Books 👋" />}
  //         >
  //           <GetStartedCard
  //             steps={[]}
  //             isLoading
  //             statusData={onboardingStatus}
  //           />
  //         </DashboardLayout>
  //       </DashboardContainer.Content>
  //     </DashboardContainer>
  //   );
  // }

  if (isBooksOnboardingComplete) {
    return (
      <DashboardContainer className="t-items-center">
        <DashboardContainer.Content
          hasMaximumWidth
          className="t-px-4 md:t-px-10"
        >
          <div className="t-flex t-gap-5 t-flex-col">
            <Header
              right={<HideBalancesAndAmounts />}
              v2
              title={`Welcome ${first_name}`}
            />
          </div>
          <div className="t-flex t-gap-8 t-flex-col t-relative t-mt-4">
            <div className="t-grid t-gap-6 t-grid-cols-1 md:t-grid-cols-2 md:t-h-96">
              <HomeActionItems />
              <CashBalance />
            </div>
            <RecentFinancials />
            <div className="t-flex t-gap-4 t-flex-col">
              <BusinessOverview />
              <BusinessInsights categorisationType={CATEGORISATION_TYPE.ALL} />
            </div>
            <div className="t-mb-8 t-w-full md:t-w-1/2">
              <PromotionalCarousel />
            </div>
          </div>
        </DashboardContainer.Content>
      </DashboardContainer>
    );
  }

  return (
    <DashboardContainer className="t-items-center">
      <DashboardContainer.Content className="t-w-full md:t-w-3/5">
        <DashboardLayout
          header={<Header v2 title={`Welcome to Inkle Books 👋`} />}
        >
          <BooksOnboarding />
        </DashboardLayout>
      </DashboardContainer.Content>
    </DashboardContainer>
  );
};

export const BooksHome = () => {
  return (
    <HideBalancesAndAmountsProvider>
      <BooksHomePage />
    </HideBalancesAndAmountsProvider>
  );
};
